import { api } from './client';

// Server-allowlisted LLM provider profile keys. Never a secret, never a URL — see
// S_PROJECT_LLM_PROFILE_ROUTING_v1.0.0.md.
export type LlmProfileKey = 'openai_personal' | 'cometapi_company';
export type AnalysisAccountProfileKey = 'personal' | 'company';

export interface AnalysisAccountProfile {
  accountKey: AnalysisAccountProfileKey;
  dataforseoProfileKey: 'dataforseo_personal' | 'dataforseo_company';
  llmProfileKey: LlmProfileKey;
  dataforseoConfigured: boolean;
  llmConfigured: boolean;
  isDefault: boolean;
}

export interface LlmProfile {
  key: LlmProfileKey;
  label: string;
  provider: 'openai' | 'cometapi';
  account: 'personal' | 'company';
  configured: boolean;
}

export type LlmProfileSource = 'explicit' | 'legacy_account_map' | 'system_default';

export interface Project {
  project_id: string;
  name: string;
  description?: string;
  default_location_code?: number;
  default_language_code?: string;
  created_at: string;
  llm_profile_key: LlmProfileKey | null;
  llm_profile_updated_at: string | null;
  resolved_llm_profile_key: string;
  llm_provider: 'openai' | 'cometapi';
  llm_account: 'personal' | 'company';
  llm_profile_source: LlmProfileSource;
  analysis_account_profile_key: AnalysisAccountProfileKey | null;
}

export const projectsApi = {
  list: () =>
    api.get<Project[]>('/projects'),

  create: (data: { name: string; description?: string; default_location_code?: number; default_language_code?: string; analysis_account_profile_key?: AnalysisAccountProfileKey | null }) =>
    api.post<Project>('/projects', data),

  delete: (id: string) =>
    api.delete(`/projects/${id}`),

  llmProfiles: () =>
    api.get<LlmProfile[]>('/projects/llm-profiles'),

  updateLlmProfile: (id: string, data: { llm_profile_key: LlmProfileKey | null; expected_updated_at: string | null }) =>
    api.patch<Project>(`/projects/${id}/llm-profile`, data),

  analysisAccountProfiles: () =>
    api.get<AnalysisAccountProfile[]>('/projects/analysis-account-profiles'),

  updateAnalysisAccountProfile: (id: string, data: { analysis_account_profile_key: AnalysisAccountProfileKey | null; expected_updated_at: string | null }) =>
    api.patch<Project>(`/projects/${id}/analysis-account-profile`, data),
};
